import { RootState } from '@/store/index';
import { ActionContext, ActionTree } from 'vuex';
import { finalize } from 'rxjs/operators';

import {
  DOWNLOAD_INSURERS_REPORTS,
  GET_INSURERS_REPORTS,
  SET_INSURERS_REPORTS,
  SET_INSURERS_REPORTS_ERRORS,
  SET_INSURERS_REPORTS_LOADING,
} from '@/types/insurers-reports.types';
import { InsurersReportsState } from '@/store/modules/insurers-reports/index';
import InsurersReportsService from '@/services/insurers-reports.service';
import { InsurersReportsSearchModel } from '@/models/backoffice/InsurersReportsSearchModel';
import { DownloadFileRequest } from '@/models/request/DownloadFileRequest';
import { Utils } from '@/globals/Utils';
import { FileMimeType } from '@/models/FileMimeType';

export const insurersReportsService = new InsurersReportsService();

export const actions: ActionTree<InsurersReportsState, RootState> = {

  [GET_INSURERS_REPORTS]: (
    { commit, dispatch, state }: ActionContext<InsurersReportsState, RootState>,
    searchObject: InsurersReportsSearchModel,
  ) => {
    commit(SET_INSURERS_REPORTS_LOADING, true);
    insurersReportsService.getInsurersReports(searchObject)
      .pipe(
        finalize(() => commit(SET_INSURERS_REPORTS_LOADING, false)),
      )
      .subscribe(
        ({ results, resultCount }) => commit(SET_INSURERS_REPORTS, { results, resultCount }),
        error => commit(SET_INSURERS_REPORTS_ERRORS, error.messages),
      );
  },

  [DOWNLOAD_INSURERS_REPORTS]: (
    { commit }: ActionContext<InsurersReportsState, RootState>,
    { fileName, fileId }: DownloadFileRequest,
  ) => {
    commit(SET_INSURERS_REPORTS_LOADING, true);

    insurersReportsService.downloadReport(fileId)
      .pipe(
        finalize(() => commit(SET_INSURERS_REPORTS_LOADING, false))
      )
      .subscribe(
        data => {
             Utils.downloadBase64File(data.body, fileName, FileMimeType.CSV);
        },
        error => commit(SET_INSURERS_REPORTS_ERRORS, error.messages),
      );
  },
};
